import React, { memo } from 'react'

import { useBreakpoints } from '../../../../providers'
import type { Variant } from '../../../../themes'
import type { IconName } from '../../../core'
import { Badge, Icon } from '../../../core'
import Inline from '../../../layout/Inline/Inline'
import { IconContainer, StyledNavLink } from './NavTabItem.styles'

export interface NavTabItemProps {
  'data-e2e'?: string
  icon?: IconName
  isActive?: boolean
  link: string
  notificationCount?: number
  onClick?: () => void
  rightLabel?: string
  rightLabelVariant?: Variant
  title: string
}

const NavTabItem = ({
  'data-e2e': dataE2e,
  icon,
  isActive,
  link,
  notificationCount = 0,
  onClick,
  rightLabel,
  rightLabelVariant = 'danger',
  title,
}: NavTabItemProps) => {
  const { isMobile } = useBreakpoints()

  return (
    <StyledNavLink
      isActive={typeof isActive === 'boolean' ? () => isActive : undefined}
      onClick={onClick}
      to={link}
      data-e2e={dataE2e}
    >
      <Inline alignment="center">
        {!isMobile && icon ? (
          <IconContainer data-e2e="icon-container">
            <Icon faStyle="far" name={icon} variant="secondary" />
            <Badge
              content={notificationCount}
              data-e2e="notification-count"
              variant="danger"
              floating
            />
          </IconContainer>
        ) : (
          <Badge
            content={notificationCount}
            data-e2e="notification-count"
            variant="danger"
            position="left"
          />
        )}

        {title}

        {rightLabel && (
          <Badge
            content={rightLabel}
            data-e2e="badge-label"
            variant={rightLabelVariant}
            position="right"
          />
        )}
      </Inline>
    </StyledNavLink>
  )
}

export default memo(NavTabItem)
